import { Timestamp } from 'firebase/firestore';
import { Issue, Rock, ActionItem, User } from '../types';

/**
 * Calculate the number of days an issue has been open
 */
export function calculateDaysOpen(firstOpenedDate: Timestamp | Date | string): number {
  const opened = firstOpenedDate instanceof Timestamp 
    ? firstOpenedDate.toDate() 
    : new Date(firstOpenedDate);
  const now = new Date();
  const diffMs = now.getTime() - opened.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays;
}

/**
 * Format a date as "Dec 13, 2025"
 */
export function formatDate(date: Timestamp | Date | string): string {
  const dateObj = date instanceof Timestamp 
    ? date.toDate() 
    : new Date(date);
  return dateObj.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
}

/**
 * Get the rock name for an issue from its relatedRockId
 */
export function getIssueRockName(issue: Issue, rocks: Rock[]): string | null {
  if (!issue.relatedRockId) return null;
  const rock = rocks.find((r) => r.id === issue.relatedRockId);
  return rock ? rock.rock : null;
}

/**
 * Get action items linked to a specific issue
 */
export function getIssueActionItems(issueId: string, actionItems: ActionItem[]): ActionItem[] {
  return actionItems.filter((item) => item.linkedIssueId === issueId);
}

/**
 * Get the assignee user object for an issue
 */
export function getIssueAssignee(issue: Issue, users: User[]): User | null {
  if (!issue.assignedToUserId) return null;
  return users.find((u) => u.id === issue.assignedToUserId) || null;
}

/**
 * Format days open as a readable string (e.g., "1 day", "5 days")
 */
export function formatDaysOpen(days: number): string {
  if (days === 0) return '0 days';
  if (days === 1) return '1 day';
  return `${days} days`;
}
